import {Component, EventEmitter, Input, Output} from '@angular/core';
import {CommonSvgIconsComponent} from "../../../../shared/components/common-svg-icons/common-svg-icons.component";
import {NgbDateStruct, NgbInputDatepicker} from "@ng-bootstrap/ng-bootstrap";
import {FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from "@angular/forms";
import {GeneralService} from "../../../../core/services/general.service";
import {TableService} from "../../../../core/services/table.service";
import {VehicleService} from "../../../../core/services/vehicle.service";

@Component({
  selector: 'app-confirmation-vehicle',
  standalone: true,
    imports: [
        CommonSvgIconsComponent,
        NgbInputDatepicker,
        ReactiveFormsModule,
        FormsModule
    ],
  templateUrl: './confirmation-vehicle.component.html',
  styleUrl: './confirmation-vehicle.component.scss'
})
export class ConfirmationVehicleComponent {
    @Input() sharedData: any;
    public activeStep: number = 4;
    public validate: boolean = false;
    public confirmationVehicleForm: FormGroup;
    @Output() activeSteps = new EventEmitter<number>();
    //public startOperationsDateModel: NgbDateStruct;

    constructor(private fb: FormBuilder, private generalService: GeneralService,private tableService: TableService, private vehicleService:VehicleService) {
        this.confirmationVehicleForm = new FormGroup({
            id:new FormControl(""),
            startOperationsDate: new FormControl<NgbDateStruct | null>(null, Validators.required),
            initialKm: new FormControl("",[
                Validators.required,
                Validators.pattern("^[0-9]+$") // Solo permite números
            ]),
        });
    }

    ngOnInit(): void {
        this.confirmationVehicleForm.reset();
        this.findVehicle();
    }

    findVehicle(){
        this.vehicleService.findVehicle(this.sharedData.vehicleId, 'confirmation').subscribe(
            (res: any) => {
                if (res.error) {
                    this.generalService.showMessage('warn', 'Error ' + res.idError + '!. ' + res.message);
                } else {
                    if(res.data != 0) {
                        this.confirmationVehicleForm.patchValue({
                            'startOperationsDate': this.convertToDatepickerFormat(res.data.vehicle.startOperationsDate),
                            'initialKm': res.data.vehicle.initialKm
                        });
                        this.generalService.showMessage('success', res.message);
                    } else {
                        this.generalService.showMessage('success', res.message);
                    }
                }
            },
            (err) => {
                this.generalService.showMessage('warn', 'Error! ' + JSON.stringify(err));
            }
        )
    }

    next() {
        if (this.confirmationVehicleForm.invalid) {
            this.validate = true;
        } else {
            this.confirmationVehicleForm.get('id')?.setValue(this.sharedData.vehicleId);
            this.vehicleService.addVehicleConfirmation(this.confirmationVehicleForm.value).subscribe(
                (res: any) => {
                    if (res.error) {
                        this.generalService.showMessage('warn', 'Error ' + res.idError + '!. ' + res.message);
                    } else {
                        this.generalService.showMessage('success', res.message);
                        this.activeSteps.emit(1);
                    }
                },
                (err) => {
                    this.generalService.showMessage('warn', 'Error! ' + JSON.stringify(err));
                }
            );
        }
    }

    /*
   * Funcion para convertir la fecha al formato de data picker
   */
    convertToDatepickerFormat(dateString: string): { year: number, month: number, day: number } {
        const [year, month, day] = dateString.split('-').map(Number);
        return { year, month, day };
    }
}
